// // ============================================================
// // src/components/admin/ServicesTab.js
// // ✅ Passes hospitalId to fetch THIS hospital's services only
// // ============================================================
// import React, { useState, useEffect } from "react";
// import api from "../../utils/api";

// const DEFAULT_SERVICES = [
//   {
//     icon: "🦷",
//     name: "General Dentistry & Cleaning",
//     desc: "Comprehensive oral examinations, professional cleanings, cavity detection, and preventive care.",
//     price: "Rs. 500",
//     from: true,
//   },
//   {
//     icon: "✨",
//     name: "Cosmetic Dentistry & Smile Makeover",
//     desc: "Transform your smile with veneers, bonding, whitening, and complete makeover packages.",
//     price: "Rs. 3,500",
//     from: true,
//   },
//   {
//     icon: "🔩",
//     name: "Dental Implants",
//     desc: "Permanent tooth replacements using titanium implants.",
//     price: "Rs. 25,000",
//     from: true,
//   },
//   {
//     icon: "📐",
//     name: "Orthodontics & Invisalign",
//     desc: "Traditional braces and clear aligner solutions.",
//     price: "Rs. 18,000",
//     from: true,
//   },
//   {
//     icon: "💉",
//     name: "Root Canal Therapy",
//     desc: "Painless root canal treatments.",
//     price: "Rs. 4,000",
//     from: true,
//   },
//   {
//     icon: "👶",
//     name: "Pediatric Dentistry",
//     desc: "Gentle, child-friendly dental care.",
//     price: "Rs. 400",
//     from: true,
//   },
// ];

// // ✅ Get hospitalId from JWT token
// function getHospitalIdFromToken() {
//   try {
//     const path = window.location.pathname;
//     const match = path.match(/\/hospital\/([^/]+)/);
//     const slug = match ? match[1] : null;
//     const key = slug
//       ? `pearlsmile_token_${slug}`
//       : "pearlsmile_token_pearlsmile";
//     const token = localStorage.getItem(key);
//     if (!token) return null;
//     const payload = JSON.parse(atob(token.split(".")[1]));
//     return payload?.hospitalId || null;
//   } catch {
//     return null;
//   }
// }

// export default function ServicesTab({ showNotify }) {
//   const [services, setServices] = useState([]);
//   const [svcToast, setSvcToast] = useState(false);

//   useEffect(() => {
//     // ✅ Pass hospitalId to get THIS hospital's services
//     const hospitalId = getHospitalIdFromToken();
//     const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
//     api
//       .get(url)
//       .then((data) => setServices(data?.length > 0 ? data : DEFAULT_SERVICES))
//       .catch(() => setServices(DEFAULT_SERVICES));
//   }, []);

//   const update = (i, key, val) =>
//     setServices((prev) =>
//       prev.map((s, idx) => (idx === i ? { ...s, [key]: val } : s)),
//     );

//   const addRow = () => {
//     setServices((prev) => [
//       ...prev,
//       {
//         icon: "🦷",
//         name: "New Service",
//         desc: "Description.",
//         price: "Rs. 0",
//         from: true,
//       },
//     ]);
//     showNotify(
//       "Service Added",
//       "Fill in the details and click Save & Update Live.",
//     );
//   };

//   const deleteRow = (i) => {
//     if (window.confirm("Delete this service?"))
//       setServices((prev) => prev.filter((_, idx) => idx !== i));
//   };

//   const save = async () => {
//     try {
//       await api.put("/services", { list: services });
//       if (typeof window.__refreshServices === "function")
//         window.__refreshServices();
//       showNotify(
//         "Services Saved! ✓",
//         "All services updated and live on the website.",
//       );
//       setSvcToast(true);
//       setTimeout(() => setSvcToast(false), 3000);
//     } catch (err) {
//       showNotify("Save Failed", err.message, true);
//     }
//   };

//   return (
//     <div>
//       <div className="admin-section-title">Services Editor</div>
//       <div className="admin-section-desc">
//         Add, edit or remove services. Click "Save & Update Live" to reflect
//         changes instantly.
//       </div>
//       <div className="admin-services-list">
//         {services.map((s, i) => (
//           <div className="admin-service-row" key={i}>
//             <div>
//               <div className="admin-row-label">Icon</div>
//               <input
//                 type="text"
//                 value={s.icon}
//                 onChange={(e) => update(i, "icon", e.target.value)}
//                 style={{ width: 70 }}
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Name</div>
//               <input
//                 type="text"
//                 value={s.name}
//                 onChange={(e) => update(i, "name", e.target.value)}
//               />
//             </div>
//             <div style={{ gridColumn: "span 1" }}>
//               <div className="admin-row-label">Description</div>
//               <textarea
//                 value={s.desc}
//                 onChange={(e) => update(i, "desc", e.target.value)}
//                 style={{
//                   width: "100%",
//                   padding: "10px 14px",
//                   border: "1.5px solid var(--gray-200)",
//                   borderRadius: 8,
//                   fontFamily: "DM Sans,sans-serif",
//                   fontSize: 13,
//                   resize: "vertical",
//                   outline: "none",
//                 }}
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Price (e.g. Rs. 500)</div>
//               <input
//                 type="text"
//                 value={s.price}
//                 onChange={(e) => update(i, "price", e.target.value)}
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Actions</div>
//               <button className="admin-del-btn" onClick={() => deleteRow(i)}>
//                 ✕
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           flexWrap: "wrap",
//           gap: 12,
//         }}
//       >
//         <button className="admin-add-btn" onClick={addRow}>
//           + Add New Service
//         </button>
//         <button className="admin-save-btn" onClick={save}>
//           Save & Update Live →
//         </button>
//         <span className={`admin-saved-toast${svcToast ? " show" : ""}`}>
//           ✅ Changes saved and live!
//         </span>
//       </div>
//     </div>
//   );
// }

// ============================================================
// src/components/admin/ServicesTab.js
// ✅ Specialty-specific defaults in admin panel
// ============================================================
import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import { useHospital } from "../../context/HospitalContext";

// ✅ All specialty defaults
const DEFAULT_SERVICES_BY_TYPE = {
  dental: [
    {
      icon: "🦷",
      name: "General Dentistry & Cleaning",
      desc: "Comprehensive oral examinations, professional cleanings, cavity detection, and preventive care.",
      price: "Rs. 500",
      from: true,
    },
    {
      icon: "✨",
      name: "Cosmetic Dentistry & Smile Makeover",
      desc: "Transform your smile with veneers, bonding, whitening, and complete makeover packages.",
      price: "Rs. 3,500",
      from: true,
    },
    {
      icon: "🔩",
      name: "Dental Implants",
      desc: "Permanent tooth replacements using titanium implants.",
      price: "Rs. 25,000",
      from: true,
    },
    {
      icon: "📐",
      name: "Orthodontics & Invisalign",
      desc: "Traditional braces and clear aligner solutions to straighten teeth and correct bite issues.",
      price: "Rs. 18,000",
      from: true,
    },
    {
      icon: "💉",
      name: "Root Canal Therapy",
      desc: "Painless root canal treatments using rotary endodontics and advanced anesthesia.",
      price: "Rs. 4,000",
      from: true,
    },
    {
      icon: "👶",
      name: "Pediatric Dentistry",
      desc: "Gentle, child-friendly dental care from infancy through adolescence.",
      price: "Rs. 400",
      from: true,
    },
  ],
  ayurved: [
    {
      icon: "🌿",
      name: "Panchakarma Detox",
      desc: "Complete body detoxification through five classical Ayurvedic therapies.",
      price: "Rs. 8,000",
      from: true,
    },
    {
      icon: "💆",
      name: "Shirodhara Therapy",
      desc: "Continuous pouring of warm medicated oil on the forehead to relieve stress and anxiety.",
      price: "Rs. 2,500",
      from: true,
    },
    {
      icon: "🤲",
      name: "Abhyanga Full Body Massage",
      desc: "Traditional full-body Ayurvedic massage with warm herbal oils.",
      price: "Rs. 1,800",
      from: true,
    },
    {
      icon: "🌸",
      name: "Nasya Treatment",
      desc: "Herbal oil administration through nasal passages to treat sinusitis and migraine.",
      price: "Rs. 1,200",
      from: true,
    },
    {
      icon: "🌱",
      name: "Kati Basti Back Pain Relief",
      desc: "Warm medicated oil treatment on the lower back to relieve chronic back pain.",
      price: "Rs. 2,000",
      from: true,
    },
    {
      icon: "✨",
      name: "Skin & Beauty Treatments",
      desc: "Ayurvedic face packs and herbal skin therapies for natural glow and rejuvenation.",
      price: "Rs. 1,500",
      from: true,
    },
  ],
  ortho: [
    {
      icon: "🦴",
      name: "Joint Replacement Surgery",
      desc: "Advanced knee, hip and shoulder replacement surgeries using minimally invasive techniques.",
      price: "Rs. 1,20,000",
      from: true,
    },
    {
      icon: "🏃",
      name: "Sports Injury Treatment",
      desc: "Diagnosis and treatment for ligament tears, fractures and sports-related conditions.",
      price: "Rs. 5,000",
      from: true,
    },
    {
      icon: "🦵",
      name: "Knee Replacement",
      desc: "Total and partial knee replacement to relieve arthritis pain and restore mobility.",
      price: "Rs. 90,000",
      from: true,
    },
    {
      icon: "🧠",
      name: "Spine Surgery",
      desc: "Advanced spinal procedures for disc problems, back pain and nerve compression.",
      price: "Rs. 1,50,000",
      from: true,
    },
    {
      icon: "🏥",
      name: "Physiotherapy & Rehabilitation",
      desc: "Personalised physiotherapy programs for post-surgical recovery and chronic conditions.",
      price: "Rs. 800",
      from: true,
    },
    {
      icon: "💊",
      name: "Arthritis Management",
      desc: "Comprehensive non-surgical management of osteoarthritis and rheumatoid arthritis.",
      price: "Rs. 2,000",
      from: true,
    },
  ],
  eye: [
    {
      icon: "👁️",
      name: "LASIK Laser Eye Surgery",
      desc: "Bladeless, painless laser vision correction to permanently eliminate spectacles.",
      price: "Rs. 35,000",
      from: true,
    },
    {
      icon: "🔬",
      name: "Cataract Surgery",
      desc: "Advanced phacoemulsification cataract surgery with premium IOL implants.",
      price: "Rs. 45,000",
      from: true,
    },
    {
      icon: "👁️",
      name: "Glaucoma Treatment",
      desc: "Complete management of glaucoma including laser therapy and surgery.",
      price: "Rs. 3,500",
      from: true,
    },
    {
      icon: "🏥",
      name: "Retina Treatment",
      desc: "Treatment for diabetic retinopathy, macular degeneration and retinal detachment.",
      price: "Rs. 8,000",
      from: true,
    },
    {
      icon: "✨",
      name: "Squint Correction",
      desc: "Surgical and non-surgical correction of squint in children and adults.",
      price: "Rs. 25,000",
      from: true,
    },
    {
      icon: "👶",
      name: "Pediatric Ophthalmology",
      desc: "Specialised eye care for children including lazy eye treatment and vision screening.",
      price: "Rs. 600",
      from: true,
    },
  ],
  cardiology: [
    {
      icon: "❤️",
      name: "Coronary Angiography",
      desc: "Minimally invasive cardiac catheterization to diagnose coronary artery disease.",
      price: "Rs. 18,000",
      from: true,
    },
    {
      icon: "💊",
      name: "Angioplasty & Stenting",
      desc: "Balloon angioplasty and stent placement to open blocked coronary arteries.",
      price: "Rs. 2,00,000",
      from: true,
    },
    {
      icon: "🏥",
      name: "Open Heart Surgery CABG",
      desc: "Coronary artery bypass grafting for multiple blockages.",
      price: "Rs. 3,50,000",
      from: true,
    },
    {
      icon: "⚡",
      name: "Pacemaker Implantation",
      desc: "Permanent pacemaker implantation for heart rhythm disorders.",
      price: "Rs. 1,20,000",
      from: true,
    },
    {
      icon: "🔬",
      name: "Preventive Cardiology",
      desc: "Complete cardiac risk assessment and lifestyle modification programs.",
      price: "Rs. 3,500",
      from: true,
    },
    {
      icon: "👶",
      name: "Pediatric Cardiology",
      desc: "Diagnosis and treatment of congenital heart defects in children.",
      price: "Rs. 2,000",
      from: true,
    },
  ],
  pediatric: [
    {
      icon: "👶",
      name: "Newborn & Neonatal Care",
      desc: "Comprehensive care for newborns including screening and vaccination.",
      price: "Rs. 1,000",
      from: true,
    },
    {
      icon: "💉",
      name: "Vaccination & Immunization",
      desc: "Complete childhood immunization as per IAP schedule.",
      price: "Rs. 500",
      from: true,
    },
    {
      icon: "📈",
      name: "Growth & Development Monitoring",
      desc: "Regular assessment of physical and developmental milestones.",
      price: "Rs. 600",
      from: true,
    },
    {
      icon: "🍎",
      name: "Child Nutrition Counseling",
      desc: "Expert dietary guidance for healthy weight and age-appropriate nutrition.",
      price: "Rs. 800",
      from: true,
    },
    {
      icon: "🫁",
      name: "Pediatric Respiratory Care",
      desc: "Treatment of asthma, bronchitis and respiratory conditions in children.",
      price: "Rs. 1,200",
      from: true,
    },
    {
      icon: "🏥",
      name: "24/7 Pediatric Emergency",
      desc: "Round-the-clock emergency care for fever, injuries and urgent child health conditions.",
      price: "Rs. 1,500",
      from: true,
    },
  ],
  general: [
    {
      icon: "🏥",
      name: "General Medicine & OPD",
      desc: "Expert consultation for all general health conditions.",
      price: "Rs. 500",
      from: true,
    },
    {
      icon: "🔬",
      name: "Pathology & Diagnostics",
      desc: "Comprehensive blood tests, imaging and advanced diagnostics.",
      price: "Rs. 300",
      from: true,
    },
    {
      icon: "🚑",
      name: "Emergency & Trauma Care",
      desc: "24/7 emergency services with fully equipped trauma centre and ICU.",
      price: "Rs. 2,000",
      from: true,
    },
    {
      icon: "🦴",
      name: "Orthopedics & Joint Care",
      desc: "Expert management of bone fractures, joint pain and orthopedic surgeries.",
      price: "Rs. 1,500",
      from: true,
    },
    {
      icon: "❤️",
      name: "Cardiology & Heart Care",
      desc: "Complete cardiac services from ECG to cardiac surgery.",
      price: "Rs. 2,500",
      from: true,
    },
    {
      icon: "🤰",
      name: "Gynecology & Maternity Care",
      desc: "Comprehensive women's health and maternity services.",
      price: "Rs. 1,000",
      from: true,
    },
  ],
};

// ✅ Get hospitalId from JWT token
function getHospitalIdFromToken() {
  try {
    const path = window.location.pathname;
    const match = path.match(/\/hospital\/([^/]+)/);
    const slug = match ? match[1] : null;
    const key = slug
      ? `pearlsmile_token_${slug}`
      : "pearlsmile_token_pearlsmile";
    const token = localStorage.getItem(key);
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.hospitalId || null;
  } catch {
    return null;
  }
}

export default function ServicesTab({ showNotify }) {
  const { hospital } = useHospital();
  const type = (hospital?.type || "dental").toLowerCase();
  const defaultServices =
    DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental;

  const [services, setServices] = useState([]);
  const [svcToast, setSvcToast] = useState(false);

  useEffect(() => {
    const hospitalId = getHospitalIdFromToken();
    const url = hospitalId ? `/services?hospitalId=${hospitalId}` : `/services`;
    api
      .get(url)
      .then((data) => setServices(data?.length > 0 ? data : defaultServices))
      .catch(() => setServices(defaultServices));
  }, [hospital?.type]); // ✅ Re-load when hospital type changes

  const update = (i, key, val) =>
    setServices((prev) =>
      prev.map((s, idx) => (idx === i ? { ...s, [key]: val } : s)),
    );

  const addRow = () => {
    setServices((prev) => [
      ...prev,
      {
        icon: "➕",
        name: "New Service",
        desc: "Description.",
        price: "Rs. 0",
        from: true,
      },
    ]);
    showNotify(
      "Service Added",
      "Fill in the details and click Save & Update Live.",
    );
  };

  const deleteRow = (i) => {
    if (window.confirm("Delete this service?"))
      setServices((prev) => prev.filter((_, idx) => idx !== i));
  };

  const save = async () => {
    try {
      await api.put("/services", { list: services });
      if (typeof window.__refreshServices === "function")
        window.__refreshServices();
      showNotify(
        "Services Saved! ✓",
        "All services updated and live on the website.",
      );
      setSvcToast(true);
      setTimeout(() => setSvcToast(false), 3000);
    } catch (err) {
      showNotify("Save Failed", err.message, true);
    }
  };

  return (
    <div>
      <div className="admin-section-title">Services Editor</div>
      <div className="admin-section-desc">
        Add, edit or remove services. Click "Save & Update Live" to reflect
        changes instantly.
      </div>
      <div className="admin-services-list">
        {services.map((s, i) => (
          <div className="admin-service-row" key={i}>
            <div>
              <div className="admin-row-label">Icon</div>
              <input
                type="text"
                value={s.icon}
                onChange={(e) => update(i, "icon", e.target.value)}
                style={{ width: 70 }}
              />
            </div>
            <div>
              <div className="admin-row-label">Service Name</div>
              <input
                type="text"
                value={s.name}
                onChange={(e) => update(i, "name", e.target.value)}
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <div className="admin-row-label">Description</div>
              <textarea
                value={s.desc}
                onChange={(e) => update(i, "desc", e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  border: "1.5px solid var(--gray-200)",
                  borderRadius: 8,
                  fontFamily: "DM Sans,sans-serif",
                  fontSize: 13,
                  resize: "vertical",
                  outline: "none",
                }}
              />
            </div>
            <div>
              <div className="admin-row-label">Price (e.g. Rs. 500)</div>
              <input
                type="text"
                value={s.price}
                onChange={(e) => update(i, "price", e.target.value)}
              />
            </div>
            <div>
              <div className="admin-row-label">Actions</div>
              <button className="admin-del-btn" onClick={() => deleteRow(i)}>
                ✕
              </button>
            </div>
          </div>
        ))}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <button className="admin-add-btn" onClick={addRow}>
          + Add New Service
        </button>
        <button className="admin-save-btn" onClick={save}>
          Save & Update Live →
        </button>
        <span className={`admin-saved-toast${svcToast ? " show" : ""}`}>
          ✅ Changes saved and live!
        </span>
      </div>
    </div>
  );
}
